import axiosInstance from '@/api/axios'

// 修改密码 短信验证码
export function sendSMSMessage(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/sendSMSMessage',
        method: 'post',
        data: parameter,
    })
}
// 修改密码 下一步校验手机号
export function verifyChangePwdSMSCode(parameter: any): Promise<any> {
    return axiosInstance({
        url: 'auth/verifyChangePwdSMSCode',
        method: 'post',
        data: parameter,
    })
}
// 修改密码 新密码就密码修改
export function changePassword(parameter: any): Promise<any> {
    return axiosInstance({
        url: 'auth/changePassword',
        method: 'post',
        data: parameter,
    })
}

//找回密码前置验证码校验
export function verifyCode(parameter: any): Promise<any> {
    return axiosInstance({
        url: 'auth/verifyChkCode',
        method: 'post',
        data: parameter,
    })
}

//找回密码
export function findPwd(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/findPassword',
        method: 'post',
        data: parameter,
    })
}

//获取配置码值
export function getscene(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/auth/code/config/get',
        method: 'post',
        data: parameter,
    })
}